import {
  AUTH_ERROR,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  SET_CURRENT_USER,
  SET_USER_CONFIG,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem("jwtToken"),
  isAuthenticated: false,
  user: null,
  config: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
      };

    case SET_USER_CONFIG:
      return {
        ...state,
        config: action.payload,
      };

    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: true,
        user: { ...action.payload },
      };
    case LOGIN_FAIL:
    case AUTH_ERROR:
    case LOGOUT_SUCCESS:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
      };

    default:
      return state;
  }
};
